"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _utils = require("../../../utils");

var _excluded = ["isSelected"],
    _excluded2 = ["isSelected", "label", "url"],
    _excluded3 = ["isSelected", "label", "url"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * This component is used internally to display links inside the Navigation component.
 */
var NavigationLink = function NavigationLink(_ref) {
  var generateLink = _ref.generateLink,
      link = _ref.link;

  // const ariaCurrent = isSelected ? "page" : undefined;
  if (generateLink) {
    var isSelected = link.isSelected,
        linkProps = _objectWithoutProperties(link, _excluded); // If a function has been provided then use it to generate the link element.


    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, generateLink(_objectSpread({
      isSelected: isSelected,
      "aria-current": isSelected ? "page" : undefined
    }, linkProps)));
  } else if ((0, _utils.isNavigationAnchor)(link)) {
    var _isSelected = link.isSelected,
        label = link.label,
        url = link.url,
        _linkProps = _objectWithoutProperties(link, _excluded2);

    return /*#__PURE__*/_react.default.createElement("a", _extends({}, _linkProps, {
      href: url,
      "aria-current": _isSelected ? "page" : undefined
    }), label);
  } else if ((0, _utils.isNavigationButton)(link)) {
    var _isSelected2 = link.isSelected,
        _label = link.label,
        _url = link.url,
        _linkProps2 = _objectWithoutProperties(link, _excluded3);

    return /*#__PURE__*/_react.default.createElement("button", _extends({}, _linkProps2, {
      "aria-current": _isSelected2 ? "page" : undefined
    }), _label);
  }

  return null;
};

var _default = NavigationLink;
exports.default = _default;